import type {SlotGameStore} from "@gamzix/slot_core";

import {CONST} from "./const";

class GameDataStore extends SlotGame.src.store.GameData {

    public freespinLevel = -1;
    
    //Is time interval: begins when the starting pop-up opens and ends when the final pop-up closes
    public isFreespinGamePopupsInProgress = false;
    public isBonusGamePopupsInProgress = false;

    setData(data: any) {
        super.setData(data);

        if (data?.freeSpins?.extra?.level >= 0){
            this.freespinLevel = Number(data?.freeSpins?.extra?.level) + 1;
        } else {
            this.freespinLevel = -1;
        }
    }

    get mode(): 'main' | 'freespins' |  'bonus' {
        if (["bonus"].includes(this.state)) {
            return "bonus";
        }

        if (["freespin"].includes(this.state)) {
            if (this.freespinLevel > 1) {
                // @ts-ignore
                return `freespins${this.freespinLevel}`;
            } else {
                return `freespins`;
            }
        }

        return "main";
    }

    get isPlatinumJackpot() {
        const countCoinsOnLine = [0, 0, 0];

        this.reels.forEach((list) => {
            list.map((el, rowId) => {
                if (el?.symbol == CONST.SYMBOLS.COIN) {
                    countCoinsOnLine[rowId]++;
                }
            })
        });

        const countFullLines = countCoinsOnLine.filter(el => el == 5).length;

        return countFullLines == 3;
    }
}

export {GameDataStore};

SlotGame.src.store.GameData = GameDataStore;